// removed by extract-text-webpack-plugin
module.exports = {"arrowWrapper":"Sg3dygh1bsgAkJZTkyK09","prevArrow":"_3L3yV68J5j-fZ_pfOlQ8tK","nextArrow":"_75y6O0-4FdUdmocT7CiKf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignPropertiesCarousel/ForeignPropertiesCarousel.scss
// module id = 1599
// module chunks = 0